import type FlowModel from 'garaje/models/flow';
import type FeatureFlagsService from 'garaje/services/feature-flags';

/**
 * Recurring invites cannot coexist with AVA-linked flows unless the
 * `ava-recurring-invites-no-reeval` flag is on. The location selector and
 * the visitor-type picker both reach a point where the resulting flow can
 * be AVA-enabled while the changeset still carries a recurring rule the
 * user set against the previous flow. Callers use this predicate to
 * decide whether to null out `recurringRule` (and `rruleUntil`, for
 * single invites) before persisting.
 */
export function shouldClearRecurringForFlow(
  flow: Pick<FlowModel, 'visitWorkflowEnabled'> | null | undefined,
  featureFlags: FeatureFlagsService,
): boolean {
  return Boolean(flow?.visitWorkflowEnabled) && !featureFlags.isEnabled('ava-recurring-invites-no-reeval');
}
